import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-multiple-sign-flow-view',
  templateUrl: './multiple-sign-flow-view.component.html',
  styleUrls: ['./multiple-sign-flow-view.component.scss']
})
export class MultipleSignFlowViewComponent implements OnInit {
  dataSource: any;
  displayedColumns: string[] = [
    'STT',
    'contractName',
    'result',
    'detail',
  ];
  content: any;
  notifyData: any
  type:any;
  notifyInfor: any
  bread: any
  constructor(
    private message: Message,
    private router: Router,
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private commonService: CommonService,
    private translate: TranslateService,
    private breadcrumbsService: BreadcrumbsService,
  ) {
    this.notifyData = JSON.parse(localStorage.getItem("notifiData"));
    this.type = JSON.parse(this.notifyData.notitficationType);
    this.content = JSON.parse(this.notifyData.content);
    this.bread = {label: 'breadcrumbs.my_created_document', url: 'search-my-created-document', params: []};
    this.handleBreadcrumbs();
  }

  ngOnInit() {
    this.handleBreadcrumbs();
    this.documentService.signContractFlowInfo(this.notifyData.objectId).subscribe(res => {
      if (!res || !res.data.lotDetails) {
        return;
      }
      this.dataSource = res.data.lotDetails;
    });
  }

  handleBreadcrumbs() {
    if(this.type == 55 || this.type == 56){
      this.breadcrumbsService.store([
        {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
        {label: 'breadcrumbs.my_documents', params: []},
        this.bread,
        {
          label: this.message.getMessage("breadcrumbs.multiple_sign_flow")
        },
      ]);
    }
    else if(this.type == 84 || this.type == 85){
      this.breadcrumbsService.store([
        {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
        {label: 'breadcrumbs.my_documents', params: []},
        this.bread,
        {
          label: this.message.getMessage("breadcrumbs.cancel_sign_flow")
        },
      ]);
    }
    else if (this.type == 86 || this.type == 87){
      this.breadcrumbsService.store([
        {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
        {label: 'breadcrumbs.my_documents', params: []},
        this.bread,
        {
          label: this.message.getMessage("breadcrumbs.confirm_sign_flow")
        },
      ]);
    }
    else if(this.type == 92 || this.type == 93) {
      this.breadcrumbsService.store([
        {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
        {label: 'breadcrumbs.my_documents', params: []},
        this.bread,
        {
          label: this.message.getMessage("breadcrumbs.multiple_delete_flow")
        },
      ]);
    }
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('sign_contract_flow.error');
      case 'PROCESSING':
      case 'CANCEL':
        return this.message.getMessage('sign_contract_flow.process');
      case 'DONE':
        return this.message.getMessage('sign_contract_flow.success');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return { 'color': 'red', 'border': '1px solid red', 'border-radius': '5px' };
      case 'PROCESSING':
      case 'CANCEL':
        return { 'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px' };
      case 'DONE':
        return { 'color': 'green', 'border': '1px solid green', 'border-radius': '5px' };
      default:
        return {};
    }
  }
}
